export async function convertToBase64Png({
  data, width, height
}: { data: Buffer; width: number; height: number }, needPrefix = true): Promise<string> {
  const { toBase64PngBuffer } = await import("@/shared/printer/png-convert");
  const bast64Img = await toBase64PngBuffer(width, height, data)
  const base64 = (needPrefix ? `data:image/png;base64,` : '') + bast64Img
  return base64
}